module.exports = __webpack_public_path__ + "static/js/2.01bfcfa6.chunk.worker.js"